import { defineMessages } from '@jutro/locale';

export default defineMessages({
    liabilityWarning1: {
        id: 'ml.account-management.wizardPageTemplate.liabilityWarning1',
        defaultMessage: 'If you suspend liability, the following coverages will also be suspended:  Bodily Injury, Property Damage, Combined Single Limit, Uninsured Motorist, Underinsured Motorist, Uninsured and Underinsured Bodily Injury, Uninsured Property Damage, Personal Injury Protection and Medical coverage.'
    },
    liabilityWarning2: {
        id: 'ml.account-management.wizardPageTemplate.liabilityWarning2',
        defaultMessage: 'In an accident, the vehicle owner and driver could be held personally liable for any damages.  The vehicle may be considered uninsured and may be subject to penalty under the state’s motor vehicle laws.'
    },
    confirmationSuccess: {
        id: 'ml.account-management.wizardPageTemplate.confirmationSuccess',
        defaultMessage: 'Your change has been processed'
    },
    confirmationError: {
        id: 'ml.account-management.wizardPageTemplate.confirmationError',
        defaultMessage: 'Action needed. Your change has been processed for the current term. However, we were unable to apply it on your renewal term. Please contact us by chat or email and we will manually process this change on your renewal for you.'
    },
    fnolConfirmationFooterText: {
        id: 'ml.fnol.common.views.ml-confirmation.As your claim progresses...',
        defaultMessage: 'As your claim progresses, visit your Claims Details page any time to review important events about your claim, review documents we have sent you, and get information about payments.  You can also check out more self-service Claim options.'
    },
    ClaimDetails:{
        id: 'ml.fnol.common.views.base-fnol-wizard.CLAIM DETAILS',
        defaultMessage: 'CLAIM DETAILS'
    },
    ReturnToYourAccount:{
        id: 'ml.fnol.common.views.base-fnol-wizard.RETURN TO YOUR ACCOUNT',
        defaultMessage: 'RETURN TO YOUR ACCOUNT'
    },
});